/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TitleLarge/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TitleLarge({
  children,
  viewPath = "/DesignSystem/TitleLarge",
  level = "h3",
  lineHeight = 1.2,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  text,
  hyphens = "none",
  textAlign = "left",
  textOverflow = "ellipsis",
  whiteSpace = "nowrap",
  overflowX = "hidden",
  order = "no",
  maxWidth
  
}) {
let dtTypographyFontweightBold = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.bold'
        })
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level={level}
 lineHeight={lineHeight}
 fontWeight={dtTypographyFontweightBold}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
 text={text}
 hyphens={hyphens}
 textAlign={textAlign}
 textOverflow={textOverflow}
 whiteSpace={whiteSpace}
 overflowX={overflowX}
 overflowY="visible"
 order={order}
 maxWidth={maxWidth}
/>
{children}
</React.Fragment>)
}